import { Component, Emit, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment/moment';
import { formatDateAgo } from '@/util/date-util';
import BriefingService from '@/service/briefing.service';
import { v4 as uuidv4 } from 'uuid';
import { namespace } from 'vuex-class';
import UserMyPageService from '@/service/userMyPage.service';
import AskGooverService from '@/service/ask-goover.service';

const appStoreState = namespace('appStore');
const briefingStore = namespace('briefingStore');

@Component({})
export default class ChatHistoryWidgetComponent extends Vue {
  @Prop({ required: true }) readonly conversationId!: string;
  @Prop({ required: true }) readonly title!: string;
  @Prop({ required: true }) readonly description!: string;
  @Prop({ required: true }) readonly chatPage!: string;
  @Prop({ required: true }) readonly date!: string;
  @Prop({ required: true }) readonly isBookmark!: boolean;
  @Prop({ required: true }) readonly linkTitle?: string;
  @Prop({ required: true }) readonly type?: string;
  @Prop({ required: false }) readonly isScrapPage?: boolean;
  @Prop({ required: false }) readonly briefingId?: string;
  @Prop({ required: false }) readonly reportId?: string;

  @Inject('userMyPageService')
  private userMyPageService: () => UserMyPageService;

  @appStoreState.Getter
  public isShowDetailReport!: boolean;
  @briefingStore.Mutation
  public setReloadAfterEditedReport!: (payload?: boolean) => void;
  @appStoreState.Mutation
  public setShowDetailReport!: (b: boolean) => void;

  @appStoreState.Mutation
  public setShowDetailArticles!: (b: boolean) => void;

  @appStoreState.Mutation
  public setShowDetailTopic!: (b: boolean) => void;

  @briefingStore.Mutation
  public setSelectedResource!: (payload?: any) => void;

  @briefingStore.Mutation
  public setIsOpenFromMyAskGoover!: (payload: boolean) => void;

  @Inject('briefingService')
  private briefingService: () => BriefingService;

  @Inject('askGooverService')
  private askGooverService: () => AskGooverService;

  @Emit('view-history') viewHistory() {}

  // @Emit('navigate') navigate() {}
  @Emit('addBookmark') addBookmark() {}

  @Emit('share')
  share(conversationId: string) {
    return conversationId;
  }

  @Watch('isShowDetailReport')
  closeModal(newVal) {
    if (!newVal) {
      this.setReloadAfterEditedReport(true);
    }
  }

  private async prepareResourceForDetail(raw: any) {
    this.setSelectedResource({});
    const originParentDocDetail = {
      _id: raw._id || '',
      acl_role: raw.acl_role || ['PUBLIC'],
      contentL: raw.content || '',
      crawler_collected_at: raw.crawler_collected_at || '',
      crawler_updated_at: raw.crawler_updated_at || '',
      image_uri: raw.image_uri || [],
      image_uri_thumbnail: raw.image_uri_thumbnail || raw.image_uri?.[0] || '',
      media_type: raw.media_type || [],
      published_at: raw.published_at || '',
      search_type: raw.search_type || [],
      service_html: raw.service_html || '',
      service_language: raw.service_language || '',
      similar_hash: raw.similar_hash || '',
      source_id: raw.source_id || '',
      source_summary: raw.source_summary || '',
      source_uri: raw.source_uri || '',
      source_uri_domain: raw.source_uri_domain || '',
      title: raw.title || '',
      writer: raw.writer || [],
      collected_quality: raw.collected_quality ?? 0,
      owner_user_key: raw.owner_user_key || '',
      private_type: raw.private_type || 'PUBLIC',
      html_raw_size: raw.html_raw_size ?? 0,
      text_size: raw.text_size ?? 0,
    };
    const data = {
      _id: raw._id,
      docId: raw._id,
      isBookmarked: raw.isBookmarked || false,
      bpId: raw.bpId || '',
      channel: raw.image_uri_thumbnail || raw.img || '',
      publishAt: raw.published_at || '',
      title: raw.title || '',
      content: raw.description || raw.content || '',
      thumbnail: raw.image_uri_thumbnail || raw.img || '',
      type: raw.type || 'REPORT',
      size: '2x1',
      userProfile: {
        lastName: raw.writer?.[0] || 'Unknown',
        imageUrl: raw.image_uri_thumbnail || raw.img || '',
        userKey: raw.owner_user_key || '',
      },
      originParentDocDetail: originParentDocDetail,
      url: raw.source_uri || '',
      videoUrl: '',
      isGroup: false,
      originDocumentType: raw.media_type?.[0] || '',
      writer: raw.writer?.[0] || '',
      owner_user_key: raw.owner_user_key || '',
      collected_quality: raw.collected_quality || 0,
      requestId: raw.requestId || '',
      reportType: raw.search_type?.[0] || '',
      privateType: raw.private_type || '',
    };
    this.setSelectedResource(data);
    return data;
  }

  mounted() {
    // console.log('Hello ChatHistoryWidgetComponent Component');
  }

  getDate(dateString: any) {
    try {
      // if (this.isScrapPage) {
      //   return dateString;
      // }
      const result = formatDateAgo(moment(dateString));
      return `${this.$t('my-create.common.label.last-update')} ` + result;
    } catch (e) {
      return dateString;
    }
  }

  deleteChatHistory(id: string) {
    this.askGooverService()
      .deleteChatHistory(id)
      .then(res => {
        this.$emit('deleteConversation', id);
      });
  }

  getReportDetail() {
    if (this.reportId) {
      const requestId = uuidv4();
      this.briefingService()
        .getReportDetail(this.reportId, requestId)
        .then(async data => {
          window.location.hash = `ask=${this.reportId}`;
          await this.prepareResourceForDetail(data?.data.body).then(value => {
            this.setSelectedResource(value);
            if (this.chatPage == 'detail') {
              this.setShowDetailArticles(true);
            } else {
              if (this.reportId.startsWith('go-public-topic-summary-')) {
                this.setShowDetailTopic(true);
              } else {
                this.setShowDetailReport(true);
              }
            }
          });
        })
        .catch(e => {
          console.error('Error in getReportDetail:', e);
          return null;
        });
    }
  }

  getIcon(type) {
    switch (type) {
      case 'briefing':
        return 'go-icon-20 go-icon-browser-share';
      case 'detail':
        return 'go-icon-20 go-icon-file-symlink';
      case 'report':
        return 'go-icon-20 go-icon-file-symlink';
      case 'company':
        return 'go-icon-20 go-icon-browser-share';
      case 'home':
        return 'go-icon-20 go-icon-home';
      case 'browser':
        return '';
      default:
        return 'go-icon-20 go-icon-file-symlink';
    }
  }

  private trackReportActivity(docId, language) {
    this.userMyPageService().saveUserActivitiesOpenReportDetail(docId, language);
  }

  navigateChat(chatPage: any, conversationId: string) {
    const language = this.$store.getters.currentLanguage ? this.$store.getters.currentLanguage : '';

    switch (chatPage) {
      case 'home': {
        this.$router.push({ path: '/home', query: { conversationId } });
        return;
      }
      case 'browser': {
        this.$router.push({ path: '/home', query: { conversationId } });
        return;
      }
      case 'briefing': {
        if (this.briefingId) {
          this.$router.push({ path: '/my-briefing/' + this.briefingId });
        }
        // else {
        //   const briefingId = conversationId.split(':')[1];
        //   this.$router.push({ path: '/my-briefing/' + briefingId });
        // }
        return;
      }
      case 'report': {
        this.getReportDetail();
        this.trackReportActivity(this.reportId, language);
        return;
      }
      case 'company': {
        if (this.briefingId) {
          this.setIsOpenFromMyAskGoover(true);
          this.$router.push({ path: '/my-briefing/company/' + this.briefingId });
        }
        // else {
        //   const briefingId = conversationId.split(':')[1];
        //   this.$router.push({ path: '/my-briefing/company/' + briefingId });
        // }
        return;
      }
      case 'detail': {
        this.getReportDetail();
        return;
      }
      // default: {
      //   this.$router.push({ path: '/home', query: { conversationId } });
      //   return;
      // }
    }
  }
}
